<template>
    <div class="search_box_wrapper" :class="{pd20:collect_w200}">
        <div class="search_box">
            <a-form layout="inline">
                <a-space :class="InputName === 'nametel'?'flex':''">
                    <a-form-item :class="InputName === 'nametel'?'addressInput':''" v-for="item in conditionList" :key="item.key" :label="item.label">
                        <a-input v-if="!item.type || item.type === 'input'" v-model="item.value" :placeholder="item.placeholder" :style="{ width: distribtn || collect_w200 ? '200px':(w200? '240px' : '180px') }" />
                        <a-select size="large" v-else-if="item.type === 'select'" v-model="item.value" :style="{width:distribtn?'200px':(w200? '240px' : '180px')}">
                            <a-select-option v-for="option in item.options" :key="option.value" :value="option.value">{{option.label}}</a-select-option>
                        </a-select>
                        <a-date-picker v-else-if="item.type === 'date'" v-model="item.value" :showToday="false" placeholder="选择日期" :disabledDate="item.key.toLowerCase().indexOf('endtime') !== -1 ? endDisabledDate : startDisabledDate" />
                        <a-range-picker v-else-if="item.type === 'dateRange'" separator="-" v-model="item.value" :placeholder="['开始时间', '结束时间']" :style="{ width: w200 ? '240px' : '180px' }"><a-icon slot="suffixIcon" type="calendar" /></a-range-picker>
                        <a-radio-group v-else-if="item.type === 'radio'" v-model="item.value">
                            <a-radio v-for="option in item.options" :key="option.value" :value="option.value">{{option.label}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-space :size="20" :class="distribtn ? 'tsX_60' : ''">
                        <a-button type="primary" @click="search" :class="SearchBtnClass">搜索</a-button>
                        <a-button class="advance_btn" v-if="moreConditionList.length > 0" @click="() => isShowMore = !isShowMore">
                            高级搜索
                            <a-icon :type="isShowMore ? 'up':'down'" />
                        </a-button>
                        <slot name="btn" :params="searchParams"></slot>
                    </a-space>
                </a-space>
            </a-form>
        </div>
        <transition name="slide-fade">
            <a-form-model layout="inline" ref="moreSearchForm" labelAlign="left" :class="['more_search_container',{'more_search_container2':distribtn}]" v-show="isShowMore">
                <a-space :size="64">
                    <a-form-item v-for="item in moreConditionList" :key="item.key" :label="item.label">
                        <a-input v-if="!item.type || item.type === 'input'" v-model="item.value" :placeholder="item.placeholder" />
                        <a-select v-else-if="item.type === 'select'" v-model="item.value">
                            <a-select-option v-for="option in item.options" :key="option.value" :value="option.value">{{option.label}}</a-select-option>
                        </a-select>
                        <a-date-picker v-else-if="item.type === 'date'" v-model="item.value" :showToday="false" :disabledDate="item.key.toLowerCase().indexOf('endtime') !== -1 ? endDisabledDate : startDisabledDate" />
                        <a-range-picker v-else-if="item.type === 'dateRange'" separator="-" v-model="item.value" />
                        <a-radio-group v-else-if="item.type === 'radio'" v-model="item.value">
                            <a-radio v-for="option in item.options" :key="option.value" :value="option.value">{{option.label}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-space>
            </a-form-model>
        </transition>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

export default {
    name: 'SearchBox',
    props: {
        isReset: {
            type: Boolean,
            required: false,
            default: false
        },
        conditions: {
            type: Array,
            required: true,
        },
        moreConditions: {
            type: Array,
            required: false,
        },
        InputName:{
            type: String,
            default: ''
        },
        w200:{
            type: Boolean,
            default: false
        },
        collect_w200:{
            type: Boolean,
            default: false
        },
        distribtn:{
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            conditionList: [],
            moreConditionList: [],
            isShowMore: false
        }
    },
    computed: {
        searchParams () {
            let res = {}

            this.conditionList.filter(({ value }) => !this.$util.isEmpty(value)).forEach(({ key, value, type }) => {
                if (type === 'date') {
                    value = value.format('YYYY-MM-DD')
                    res[key] = value
                } else if (type === 'dateRange') {
                    const [start, end] = value
                    res['start_' + key] = start.format('YYYY-MM-DD')
                    res['end_' + key] = end.format('YYYY-MM-DD')
                } else {
                    res[key] = value
                }
            })

            if (this.isShowMore) {
                this.moreConditionList.filter(({ value }) => !this.$util.isEmpty(value)).forEach(({ key, value, type }) => {
                    if (type === 'date') {
                        value = value.format('YYYY-MM-DD')
                        res[key] = value
                    } else if (type === 'dateRange') {
                        const [start, end] = value
                        res['start_' + key] = start.format('YYYY-MM-DD')
                        res['end_' + key] = end.format('YYYY-MM-DD')
                    } else {
                        res[key] = value
                    }
                })
            }
            return res
        },

        SearchBtnClass (){
            return [
             'search_btn',
             {
               search_btn2: this.InputName === 'nametel',
               search_btn3: this.w200,
               search_btn4: this.collect_w200,
             },
           ]
        }
    },
    methods: {
        search () {
            this.$emit('search', this.searchParams)
        },
        startDisabledDate (date) {
            let { value } = this.conditionList.find(({ key }) => {
                return key.toLowerCase().indexOf('endtime') !== -1
            })
            if (!value) return false
            return date > value
        },
        endDisabledDate (date) {
            let { value } = this.conditionList.find(({ key }) => {
                return key.toLowerCase().indexOf('starttime') !== -1
            })
            if (!value) return false
            return date < value
        }
    },
    watch: {
        conditions: {
            handler (val) {
                console.log(val);

                this.conditionList = JSON.parse(JSON.stringify(val))
            },
            deep: true,
            immediate: true
        },
        moreConditions: {
            handler (val) {
                if (typeof val != 'undefined' && val.length > 0) {
                    this.moreConditionList = JSON.parse(JSON.stringify(val))
                }
            },
            deep: true,
            immediate: true
        },
        isReset () {
            this.conditionList = JSON.parse(JSON.stringify(this.conditions))
            if (this.moreConditions.length > 0) {
                this.moreConditionList = JSON.parse(JSON.stringify(this.moreConditions))
            }
        }
    }
}
</script>

<style scoped>
.search_box_wrapper {
    padding: 20px 30px;
    background: #ffffff;
}
.pd20{
    padding: 20px;
}
.search_box {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.search_box >>> .ant-btn {
    min-width: 86px;
}

::v-deep .ant-space {
    flex-wrap: wrap;
}
.more_search_container {
    margin-top: 20px;
    max-width: 900px;
    display: flex;
    flex-wrap: wrap;
}

.more_search_container2 {
    margin-top: 0;
}

.more_search_container2 input,
.more_search_container2 >>>.ant-calendar-picker-input{
    width: 200px;
}
.ant-col.ant-form-item-control-wrapper{
  width: 100px !important;
}

>>>.search_btn{
    width: 86px;
    height: 36px;
    border-radius: 5px;
    border: 1px solid #FD5902;
    background: #fd5902 !important;
    /*background: unset!important;*/
    font-size: 14px;
    font-weight: 500;
    /*color: #FD5902!important;*/
    color: #ffffff !important;
    font-family: "PingFang SC";
    margin-bottom: 10px;
    text-shadow: none;
}

>>>.advance_btn{
    margin-bottom: 10px;
}

>>> .ant-form {
    width: 100%;
}

>>> .flex{
    display: flex;
    width: 100%;
    justify-content: space-between;
    position: relative;
}

>>>.addressInput input{
    width: 280px!important;
    height: 30px;
    background: #F8F7F7;
}

>>>.search_btn2{
    position: absolute;
    top: 5px;
    left: 300px;
    width: 86px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #FD5902;
    background: #FD5902!important;
    color: #fff!important;
    font-family: "PingFang SC";
    font-size: 13px;
}

>>>.search_btn3{
    width: 86px;
    height: 30px;
    border-radius: 5px;
    border: 1px solid #FD5902;
    background: #FD5902!important;
    color: #fff!important;
    font-family: "PingFang SC";
    font-size: 13px;
    /*transform: translateX(-50px);*/
}

>>>.search_btn4{
    background: #fff!important;
    color: #FD5902!important;
    /*transform: translateX(-60px);*/
}

>>>.ant-input{
    height: 36px !important;
    font-size: 14px;
}
>>>.ant-select-selection--single {
  height: 36px !important;
}
>>>.ant-select-selection__rendered {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 14px;
}

.pd20 >>>.ant-form-item-label>label{
    color: #666666;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
}

>>>.tsX_60{
    /*transform:translateX(-60px);*/
}

>>> .tsX_60 .ant-btn {
    width: 86px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px!important;
}

>>> .tsX_60 .advance_btn{
    color: #333;
}

>>> .tsX_60 .advance_btn i{
    margin-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/SearchBox.vue